import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, withModifiers as _withModifiers, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "asset-map-controls" }
const _hoisted_2 = { class: "asset-map-controls__zoom" }
const _hoisted_3 = ["title"]
const _hoisted_4 = ["title"]
const _hoisted_5 = ["title"]
const _hoisted_6 = ["title"]
const _hoisted_7 = { class: "asset-map-controls__settings-menu" }
const _hoisted_8 = { class: "asset-map-controls__settings-title" }
const _hoisted_9 = { class: "asset-map-controls__settings-styles" }
const _hoisted_10 = ["onClick"]
const _hoisted_11 = ["title"]
const _hoisted_12 = { key: 0 }
const _hoisted_13 = {
  key: 0,
  class: "location-cards-panel__body"
}
const _hoisted_14 = { class: "location-cards-panel__count" }
const _hoisted_15 = { class: "location-cards-panel__list" }
const _hoisted_16 = {
  key: 0,
  class: "location-cards-panel__loading"
}
const _hoisted_17 = ["onMouseenter", "onClick"]
const _hoisted_18 = { class: "location-card__icon" }
const _hoisted_19 = { class: "location-card__content" }
const _hoisted_20 = { class: "location-card__title-row" }
const _hoisted_21 = { class: "location-card__title" }
const _hoisted_22 = {
  key: 0,
  class: "location-card__address"
}
const _hoisted_23 = { class: "location-card__subtitle" }
const _hoisted_24 = { class: "location-card__badge" }
const _hoisted_25 = {
  key: 0,
  class: "location-cards-panel__empty"
}
const _hoisted_26 = { class: "assets-modal__header" }
const _hoisted_27 = { class: "header-content" }
const _hoisted_28 = { class: "header-text" }
const _hoisted_29 = { class: "assets-modal__content" }
const _hoisted_30 = { class: "filter-section" }
const _hoisted_31 = { class: "filter-input-wrapper" }
const _hoisted_32 = ["placeholder"]
const _hoisted_33 = {
  key: 0,
  class: "no-results"
}
const _hoisted_34 = ["onClick"]
const _hoisted_35 = { class: "asset-card__icon-wrapper" }
const _hoisted_36 = { class: "asset-card__icon" }
const _hoisted_37 = { class: "asset-card__content" }
const _hoisted_38 = { class: "asset-card__name" }
const _hoisted_39 = { class: "asset-card__params" }
const _hoisted_40 = { class: "param-chip" }
const _hoisted_41 = {
  key: 0,
  class: "param-chip"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _cache[28] || (_cache[28] = _createElementVNode("div", { id: "map" }, null, -1)),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("button", {
          class: "asset-map-controls__btn asset-map-controls__btn--top",
          title: _ctx.$t('components.map.controls.zoomIn'),
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.zoomIn && _ctx.zoomIn(...args)))
        }, [...(_cache[12] || (_cache[12] = [
          _createElementVNode("i", { class: "bi bi-plus-lg" }, null, -1)
        ]))], 8, _hoisted_3),
        _createElementVNode("button", {
          class: "asset-map-controls__btn",
          title: _ctx.$t('components.map.controls.zoomOut'),
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.zoomOut && _ctx.zoomOut(...args)))
        }, [...(_cache[13] || (_cache[13] = [
          _createElementVNode("i", { class: "bi bi-dash-lg" }, null, -1)
        ]))], 8, _hoisted_4)
      ]),
      (_ctx.locationCards.length > 0)
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            class: "asset-map-controls__center",
            title: _ctx.$t('components.assetsMap.controls.fitAll'),
            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.fitAllAssets && _ctx.fitAllAssets(...args)))
          }, [...(_cache[14] || (_cache[14] = [
            _createElementVNode("i", { class: "bi bi-arrows-fullscreen" }, null, -1)
          ]))], 8, _hoisted_5))
        : _createCommentVNode("", true),
      _createElementVNode("div", {
        class: _normalizeClass(["asset-map-controls__settings", { 'is-open': _ctx.showMapStyleMenu }])
      }, [
        _createElementVNode("button", {
          class: _normalizeClass(["asset-map-controls__settings-toggle", { 'asset-map-controls__settings-toggle--active': _ctx.showMapStyleMenu }]),
          title: _ctx.$t('components.map.controls.settings'),
          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.showMapStyleMenu = !_ctx.showMapStyleMenu))
        }, [...(_cache[15] || (_cache[15] = [
          _createElementVNode("i", { class: "bi bi-sliders" }, null, -1)
        ]))], 10, _hoisted_6),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.$t('components.map.controls.baseMap')), 1),
          _createElementVNode("div", _hoisted_9, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.availableProviders, (p) => {
              return (_openBlock(), _createElementBlock("button", {
                key: p.id,
                class: _normalizeClass(["asset-map-controls__settings-style", { 'is-active': _ctx.selectedProvider === p.id }]),
                onClick: ($event: any) => (_ctx.selectProvider(p.id))
              }, [
                _createElementVNode("span", {
                  class: "asset-map-controls__settings-style-preview",
                  style: _normalizeStyle({ background: p.preview })
                }, null, 4),
                _createElementVNode("span", null, _toDisplayString(p.label), 1)
              ], 10, _hoisted_10))
            }), 128))
          ])
        ])
      ], 2)
    ]),
    _createElementVNode("div", {
      class: _normalizeClass(["location-cards-panel", { 'location-cards-panel--collapsed': !_ctx.showCardsPanel }])
    }, [
      _createElementVNode("button", {
        class: "location-cards-panel__toggle",
        onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.toggleCardsPanel && _ctx.toggleCardsPanel(...args))),
        title: _ctx.showCardsPanel ? _ctx.$t('components.assetsMap.list.hideList') : _ctx.$t('components.assetsMap.list.showList')
      }, [
        _createElementVNode("i", {
          class: _normalizeClass(["bi", _ctx.showCardsPanel ? 'bi-chevron-left' : 'bi-geo-alt-fill'])
        }, null, 2),
        (!_ctx.showCardsPanel && _ctx.locationCards.length)
          ? (_openBlock(), _createElementBlock("span", _hoisted_12, _toDisplayString(_ctx.locationCards.length), 1))
          : _createCommentVNode("", true)
      ], 8, _hoisted_11),
      (_ctx.showCardsPanel)
        ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
            _createElementVNode("div", {
              class: "location-cards-panel__header",
              onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.toggleCardsPanel && _ctx.toggleCardsPanel(...args)))
            }, [
              _cache[16] || (_cache[16] = _createElementVNode("i", { class: "bi bi-geo-alt-fill" }, null, -1)),
              _createElementVNode("span", null, _toDisplayString(_ctx.$t('components.assetsMap.list.title')), 1),
              _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.locationCards.length), 1),
              _cache[17] || (_cache[17] = _createElementVNode("i", { class: "bi bi-chevron-left location-cards-panel__collapse-icon" }, null, -1))
            ]),
            _createElementVNode("div", _hoisted_15, [
              (!_ctx.cardsLoaded)
                ? (_openBlock(), _createElementBlock("div", _hoisted_16, [...(_cache[18] || (_cache[18] = [
                    _createElementVNode("span", {
                      class: "spinner-border location-cards-panel__spinner",
                      role: "status"
                    }, null, -1)
                  ]))]))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.locationCards, (card) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: card.key,
                        class: _normalizeClass(["location-card", { 'location-card--active': _ctx.hoveredCardKey === card.key }]),
                        onMouseenter: ($event: any) => (_ctx.hoveredCardKey = card.key),
                        onMouseleave: _cache[6] || (_cache[6] = ($event: any) => (_ctx.hoveredCardKey = null)),
                        onClick: ($event: any) => (_ctx.onCardClick(card))
                      }, [
                        _createElementVNode("div", _hoisted_18, [
                          _createElementVNode("i", {
                            class: _normalizeClass(["bi", card.icon])
                          }, null, 2)
                        ]),
                        _createElementVNode("div", _hoisted_19, [
                          _createElementVNode("div", _hoisted_20, [
                            _createElementVNode("h4", _hoisted_21, _toDisplayString(card.label || `${card.lat.toFixed(4)}, ${card.lng.toFixed(4)}`), 1),
                            (card.type)
                              ? (_openBlock(), _createElementBlock("span", {
                                  key: 0,
                                  class: _normalizeClass(["location-card__type-badge", `location-card__type-badge--${card.type}`])
                                }, _toDisplayString(_ctx.$t('components.wirepasLocations.locationTypes.' + card.type)), 3))
                              : _createCommentVNode("", true)
                          ]),
                          (card.address)
                            ? (_openBlock(), _createElementBlock("p", _hoisted_22, _toDisplayString(card.address), 1))
                            : _createCommentVNode("", true),
                          _createElementVNode("p", _hoisted_23, _toDisplayString(card.count) + " " + _toDisplayString(_ctx.deviceCountLabel(card.count)), 1)
                        ]),
                        _createElementVNode("div", _hoisted_24, _toDisplayString(card.count), 1)
                      ], 42, _hoisted_17))
                    }), 128)),
                    (_ctx.locationCards.length === 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                          _cache[19] || (_cache[19] = _createElementVNode("i", { class: "bi bi-geo" }, null, -1)),
                          _createElementVNode("p", null, _toDisplayString(_ctx.$t('components.assetsMap.list.empty')), 1)
                        ]))
                      : _createCommentVNode("", true)
                  ], 64))
            ])
          ]))
        : _createCommentVNode("", true)
    ], 2),
    _createVNode(_Transition, { name: "modal" }, {
      default: _withCtx(() => [
        (_ctx.showModal)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "modal-overlay",
              onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args)))
            }, [
              _createElementVNode("div", {
                class: "assets-modal",
                onClick: _cache[10] || (_cache[10] = _withModifiers(() => {}, ["stop"]))
              }, [
                _createElementVNode("div", _hoisted_26, [
                  _createElementVNode("div", _hoisted_27, [
                    _cache[20] || (_cache[20] = _createElementVNode("div", { class: "header-icon" }, [
                      _createElementVNode("i", { class: "bi bi-geo-alt-fill" })
                    ], -1)),
                    _createElementVNode("div", _hoisted_28, [
                      _createElementVNode("h3", null, _toDisplayString(_ctx.$t('components.assetsMap.modal.title')), 1),
                      _createElementVNode("p", null, _toDisplayString(_ctx.modalAssets.length) + " " + _toDisplayString(_ctx.deviceCountLabel(_ctx.modalAssets.length)), 1)
                    ])
                  ]),
                  _createElementVNode("button", {
                    onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args))),
                    class: "close-btn"
                  }, [...(_cache[21] || (_cache[21] = [
                    _createElementVNode("i", { class: "bi bi-x" }, null, -1)
                  ]))])
                ]),
                _createElementVNode("div", _hoisted_29, [
                  _createElementVNode("div", _hoisted_30, [
                    _createElementVNode("div", _hoisted_31, [
                      _cache[22] || (_cache[22] = _createElementVNode("i", { class: "bi bi-search" }, null, -1)),
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.filterText) = $event)),
                        type: "text",
                        placeholder: _ctx.$t('components.assetsMap.modal.searchPlaceholder'),
                        class: "filter-input"
                      }, null, 8, _hoisted_32), [
                        [_vModelText, _ctx.filterText]
                      ]),
                      (_ctx.filterText)
                        ? (_openBlock(), _createElementBlock("i", {
                            key: 0,
                            onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.filterText = '')),
                            class: "bi bi-x-circle clear-icon"
                          }))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  (_ctx.filteredModalAssets.length === 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                        _cache[23] || (_cache[23] = _createElementVNode("i", { class: "bi bi-search" }, null, -1)),
                        _createElementVNode("p", null, _toDisplayString(_ctx.$t('components.assetsMap.modal.noResults')), 1)
                      ]))
                    : _createCommentVNode("", true),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredModalAssets, (asset, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: asset.id,
                      class: "asset-card",
                      style: _normalizeStyle({ animationDelay: `${index * 0.06}s` }),
                      onClick: ($event: any) => (_ctx.goToAsset(asset.id))
                    }, [
                      _createElementVNode("div", _hoisted_35, [
                        _createElementVNode("div", _hoisted_36, [
                          _createElementVNode("i", {
                            class: _normalizeClass(["bi", _ctx.getAssetIcon(asset)])
                          }, null, 2)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_37, [
                        _createElementVNode("h4", _hoisted_38, _toDisplayString(asset.name || asset.serial_number || _ctx.$t('components.assetsMap.modal.unknownAsset')), 1),
                        _createElementVNode("div", _hoisted_39, [
                          _createElementVNode("span", _hoisted_40, [
                            _cache[24] || (_cache[24] = _createElementVNode("i", { class: "bi bi-thermometer-half" }, null, -1)),
                            _createTextVNode(" " + _toDisplayString(_ctx.getTemperature(asset)), 1)
                          ]),
                          (_ctx.getHumidity(asset))
                            ? (_openBlock(), _createElementBlock("span", _hoisted_41, [
                                _cache[25] || (_cache[25] = _createElementVNode("i", { class: "bi bi-droplet-half" }, null, -1)),
                                _createTextVNode(" " + _toDisplayString(_ctx.getHumidity(asset)), 1)
                              ]))
                            : _createCommentVNode("", true),
                          (_ctx.getBatteryStatus(asset) !== null)
                            ? (_openBlock(), _createElementBlock("span", {
                                key: 1,
                                class: _normalizeClass(["param-chip", _ctx.getBatteryStatusClass(asset)])
                              }, [
                                _cache[26] || (_cache[26] = _createElementVNode("i", { class: "bi bi-battery-charging" }, null, -1)),
                                _createTextVNode(" " + _toDisplayString(_ctx.getBatteryStatus(asset)), 1)
                              ], 2))
                            : _createCommentVNode("", true)
                        ])
                      ]),
                      _cache[27] || (_cache[27] = _createElementVNode("div", { class: "asset-card__arrow" }, [
                        _createElementVNode("i", { class: "bi bi-chevron-right" })
                      ], -1))
                    ], 12, _hoisted_34))
                  }), 128))
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ], 64))
}